import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { squareApiService } from "../services/squareApiService";
import { fromSquareConnectionDtoToSquareConnection } from "../types/squareTypes";

export const squareKeys = {
  all: ["square"] as const,
  detail: (businessId: string) => [...squareKeys.all, businessId] as const,
};

export const useSquareConnection = (businessId: string) => useQuery({
  queryKey: squareKeys.detail(businessId),
  queryFn: async ({ signal }) => fromSquareConnectionDtoToSquareConnection(
    await squareApiService.getByBusinessId(businessId, signal),
  ),
  staleTime: 0,
  retry: false,
});

export const useDisconnectSquare = (businessId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => squareApiService.disconnect(businessId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: squareKeys.detail(businessId) }),
  });
};
